import { render, staticRenderFns } from "./phd_test.vue?vue&type=template&id=0ac223e8&lang=html&"
import script from "./phd_test.vue?vue&type=script&lang=js&"
export * from "./phd_test.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports